const selectors = {
  imageWithTextCounter: '[data-image-with-text-counter]',
};

const imageWithTextSectionCounters = () => {
  const sectionCounters = Array.from(document.querySelectorAll(selectors.imageWithTextCounter));
  if (!sectionCounters) return;
  for (let i = 0; i < sectionCounters.length; i++) {
    const imageWIthTextSection = sectionCounters[i];
    const sectionCount = i + 1;
    imageWIthTextSection.textContent = sectionCount;
  }
};

export default imageWithTextSectionCounters;
